import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"50%"} }, [
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2 words" }, "25% bonus for 20+ apes  "),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2 words" }, "20% bonus for 10-19 apes  "),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2 words" }, "10% bonus for 5-9 apes  "),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2 words" }, "5% bonus for 3-4 apes  ")
  ]),
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"50%"} }, [
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2 words" }, "1/1 Apes: 50 $MILEZ a day"),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2 words" }, "Epic Apes: 25 $MILEZ a day"),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2 words" }, "Rare Apes: 15 $MILEZ a day"),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2 words" }, "Common Apes: 10 $MILEZ a day")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, _hoisted_3))
}